// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__DfYpV","item":"styles_item__AwAFg","title":"styles_title__WXRFf","value":"styles_value__MUlA5"};